import { BaseURl } from "./BaseApiUrl";

//https://testcockpit.p2k.in/api/Dashboard/getDashboardLiveCallDetailsCnt/v1/?userUUID=1d33299f-f015-11ee-91f2-b8ca3ad15bed
export const getOpsDashboardDayWiseWOExeCntAPIURL = BaseURl + "Dashboard/getOpsDashboardWOExecutionsCnt/v1/";